import React, { useState } from 'react';
import Navbar from '../components/NavbarLanding';
import msgFrame from '../assets/msg frame.png';
import phoneFrame from '../assets/phone frame.png';
import locationFrame from '../assets/location frame.png';
import peopleFrame from '../assets/people frame.png';
import bookFrame from '../assets/book frame.png';
import heartFrame from '../assets/heart frame.png';
import { useNavigate } from 'react-router-dom';
import brainFrame from '../assets/Brain frame.png';
import triangle from '../assets/triangle.png';
import starFrame from '../assets/star frame.png';
import search from '../assets/search.png';
import notification from '../assets/notification.png';
import message from '../assets/message.png';
import Sidebar from '../components/Sidebar';
import Footer from './Footer';
import updated from '../assets/updated.png';
import free from '../assets/free.png';
import Premium from '../assets/Premium.png'
import api from '../sever/Api';
import { loadStripe } from '@stripe/stripe-js';
import Standard from '../assets/Standard.png';
import premiumCrown from '../assets/premium crown.png'
import closer from '../assets/closer.png'

const sampleQuestions = [
    {
        question: 'You\'re planning a group trip. What\'s your role?',
        options: [
            'I organize everything and make sure everyone is on track.',
            'I suggest fun ideas and keep the mood light.',
            'I help solve problems and keep things running smoothly.',
            'I go with the flow and support others\' plans.'
        ]
    }
];

const PersonalityTestLanding = () => {
    const [selected, setSelected] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showUpgradePopup, setShowUpgradePopup] = useState(false);

    const canTakeFreeTest = () => {
        try {
            const userStr = localStorage.getItem('user');
            const user = userStr ? JSON.parse(userStr) : null;
            const isPremium = user && (user.role === 'premium' || user.role === 'admin');
            if (isPremium) return true;
            const used = localStorage.getItem('freeTestUsed');
            return used !== '1';
        } catch (_) { return false; }
    };

    const markFreeTestUsed = () => {
        try { localStorage.setItem('freeTestUsed', '1'); } catch (_) {}
    };

    const handleTakeTestClick = () => {
        if (canTakeFreeTest()) {
            // allow one free navigation; mark as used so next time popup shows
            markFreeTestUsed();
            navigate('/login');
        } else {
            setShowUpgradePopup(true);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
    };
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    const startCheckout = async (plan) => {
        try {
            const successUrl = `${window.location.origin}/?checkout=success&plan=${encodeURIComponent(plan)}`;
            const cancelUrl = `${window.location.origin}/?checkout=cancelled&plan=${encodeURIComponent(plan)}`;
            const response = await api.post('/api/billing/create-checkout-session', {
                plan,
                successUrl,
                cancelUrl,
            });
            const { id, url } = response.data || {};
            const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
            if (id && publishableKey) {
                const stripe = await loadStripe(publishableKey);
                const { error } = await stripe.redirectToCheckout({ sessionId: id });
                if (error) {
                    console.error('Stripe redirect error:', error);
                    if (url) window.location.href = url;
                }
            } else if (url) {
                window.location.href = url;
            }
        } catch (error) {
            console.error('Checkout error', error);
            const serverMessage = error?.response?.data?.message;
            const serverError = error?.response?.data?.error;
            alert(serverMessage || serverError || 'Unable to start checkout right now. Please try again later.');
        }
    };

    return (

        <div className="flex flex-col min-h-screen w-full overflow-x-hidden" style={{ background: 'linear-gradient(90deg, #FFFFFF 0%, #EFF6FF 100%, #F9FAFB 100%)' }}>

            <div className=' flex-1 relative'>

                <Navbar
                    toggleSidebar={toggleSidebar}
                />

                {/* Decorative brain on left - updated position and style */}
                <img src={brainFrame} alt="brain" style={{ position: 'absolute', left: '100px', top: '480px', width: '30px', height: '25px', opacity: 0.5, zIndex: 1, filter: 'hue-rotate(320deg) brightness(1.2)' }} className="hidden lg:block" />
                {/* Heart icon to the right of rounded rectangle */}
                <img src={heartFrame} alt="heart" style={{
                    position: 'absolute',
                    top: '250px',
                    left: '1280px',
                    width: '29px',
                    height: '24px',
                    opacity: 1,
                    zIndex: 2
                }} className="hidden xl:block" />
                {/* Large rounded rectangle near heart */}
                <div style={{
                    position: 'absolute',
                    top: '130px',
                    left: '1140px',
                    width: '120px',
                    height: '100px',
                    opacity: '7%',
                    borderRadius: '9999px',
                    background: '#E1BEE7',
                    zIndex: 1
                }} className="hidden xl:block" />
                {/* Triangle icon */}
                <img src={triangle} alt="triangle" style={{ position: 'absolute', top: '180px', left: '400px', width: '25px', height: '25px', objectFit: 'contain', borderStyle: 'solid', borderColor: '#4CAF50', zIndex: 2 }} className="hidden lg:block" />
                {/* Star icon */}
                <img src={starFrame} alt="star" style={{ position: 'absolute', top: '320px', left: '400px', transform: 'translateX(-50%)', width: '30px', height: '30px', objectFit: 'contain', zIndex: 2 }} className="hidden lg:block" />
                {/* Decorative square element */}
                <div style={{
                    position: 'absolute',
                    top: '230px',
                    left: '945px',
                    width: '24px',
                    height: '22px',
                    border: '2px solid #a259c6',
                    borderRadius: '6px',
                    opacity: '0.7',
                    background: 'transparent',
                    zIndex: 2,
                    transform: 'rotate(0deg)'
                }} className="hidden xl:block" />
                {/* Rounded rectangle background behind heading */}
                <div style={{
                    position: 'absolute',
                    top: '90px',
                    left: '50px',
                    width: '120px',
                    height: '100px',
                    opacity: '7%',
                    borderRadius: '9999px',
                    background: '#FFB8B3',
                    zIndex: 1
                }} className="hidden lg:block" />

                {/* Personality Test Intro Section */}
                <section className="w-full flex flex-col items-center justify-center mt-28 pb-10 bg-transparent px-4 sm:px-6 lg:px-8">
                    <div className="w-full max-w-7xl mx-auto">
                        <h2
                            className="text-center mb-4 text-2xl sm:text-3xl md:text-4xl lg:text-5xl"
                            style={{
                                fontFamily: 'Roboto Slab, serif',
                                fontWeight: 700,
                                fontStyle: 'normal',
                                lineHeight: '1.2',
                                letterSpacing: '0%',
                            }}
                        >
                            Personality Test
                        </h2>
                        <p className="text-gray-600 text-sm sm:text-base md:text-lg text-center max-w-4xl mx-auto">
                            <span style={{ textAlign: 'center', display: 'block' }}>
                                Discover the complete spectrum of human personality through our comprehensive 12-type system. Each type represents a unique combination of traits, strengths, and perspectives that shape how you interact with the world.
                            </span>
                        </p>
                    </div>
                </section>

                {/* Test Cards Grid Section */}
                <section className="w-full px-4 sm:px-6 lg:px-8 pb-12">
                    <div className="w-full max-w-7xl mx-auto">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
                            {[
                                {
                                    title: 'DISC Assessment',
                                    desc: 'Gain clarity on your personality and behavior style as well as others by measuring four traits: Dominance, Influence, Steadiness, and Conscientiousness.',
                                    icon: require('../assets/person frame 1.png'),
                                    bg: '#FFE5E1',
                                    frameColor: '#F9B6B0',
                                    badge: 'Career',
                                    badgeColor: '#F9B6B0',
                                    btnColor: '#F9B6B0',
                                },
                                {
                                    title: 'Essence Echo',
                                    desc: 'An honest introspection reflecting on your unique values, passions, and impact to reveal your authentic self and core essence. Start with what you know and we will handle the rest.',
                                    icon: require('../assets/person frame 2.png'),
                                    bg: '#F3E5F5',
                                    frameColor: '#B39DDB',
                                    badge: 'Career',
                                    badgeColor: '#CE93D8',
                                    btnColor: '#CE93D8',
                                },
                                {
                                    title: 'Enneagram Finder',
                                    desc: 'Iden fy your core motivation, desires and fears among nine types of interconnected personalities. Explore deep-seated patterns that influence your life path, and see where they can lead',
                                    icon: require('../assets/person frame 3.png'),
                                    bg: '#E8F5E8',
                                    frameColor: '#A5D6A7',
                                    badge: 'Self',
                                    badgeColor: '#A5D6A7',
                                    btnColor: '#A5D6A7',
                                },
                                {
                                    title: 'Big Five Personality Test',
                                    desc: 'Dive into the five broader dimensions that define your personality and influence your worldview. Measuring Openness, Conscien ousness, Extraversion, Agreeableness, and Neuro cism (OCEAN).',
                                    icon: require('../assets/person frame  4.png'),
                                    bg: '#E3F2FD',
                                    frameColor: '#90CAF9',
                                    badge: 'Self',
                                    badgeColor: '#90CAF9',
                                    btnColor: '#90CAF9',
                                },
                                {
                                    title: 'Emotional IQ Test',
                                    desc: 'Assess your emo onal intelligence to elevate self-awareness and connec on with others  Foster empathy and successful relationships by enhancing your emoional capabilities.',
                                    icon: require('../assets/person frame 5.png'),
                                    bg: '#FFF3E0',
                                    frameColor: '#FFD59A',
                                    badge: 'Career',
                                    badgeColor: '#FFD59A',
                                    btnColor: '#FFCC80',
                                },
                                {
                                    title: 'Learning Style Assessment',
                                    desc: 'Discover your optimal learning method to enhance educational and professional growth. Tailor your development to your unique style for personal and professional growth at the highest level',
                                    icon: require('../assets/person frame 6.png'),
                                    bg: '#FCE4EC',
                                    frameColor: '#F8BBD9',
                                    badge: 'Self',
                                    badgeColor: '#F8BBD9',
                                    btnColor: '#F8BBD9',
                                },
                                {
                                    title: 'Character Strengths Survey',
                                    desc: 'Iden fy and rank the core 24 posi ve virtues that mo vate your ac ons and decisions, creating a path for authentic living. Enhance personal growth and enrich interac ons with these insights.',
                                    icon: require('../assets/tree.png'),
                                    bg: '#E8F5E8',
                                    frameColor: '#A5D6A7',
                                    badge: 'Self',
                                    badgeColor: '#A5D6A7',
                                    btnColor: '#C5E1A5',
                                },
                                {
                                    title: 'Competency Quiz',
                                    desc: 'Evaluate your key skills to understand how they align with your long-term aspira ons. Pinpoint development areas to strategically advance your life and career goals.',
                                    icon: require('../assets/person frame 8.png'),
                                    bg: '#F3E5F5',
                                    frameColor: '#B39DDB',
                                    badge: 'Career',
                                    badgeColor: '#B39DDB',
                                    btnColor: '#B39DDB',
                                },
                                {
                                    title: 'High 5 Strengths Test',
                                    desc: 'Discover your top five strengths and natural talents by measuring your recurring thought patterns, mo va ons and behaviors. Embrace your innate strengths to transform your life starting now',
                                    icon: require('../assets/target.png'),
                                    bg: '#FFE5E1',
                                    frameColor: '#F9B6B0',
                                    badge: 'Self',
                                    badgeColor: '#F9B6B0',
                                    btnColor: '#FF9595',
                                },
                                {
                                    title: 'TypeFusion Finder 16 Types inspired by MBTI',
                                    desc: 'Reveal your personality type out of the 16 types by using four different pairs of preferences to gain greater insight. This helps to showcase how they a4ect your decisions and interpersonal interactions.',
                                    icon: require('../assets/star frame.png'),
                                    bg: 'rgba(52,129,254,0.10)',
                                    frameColor: '#90CAF9',
                                    badge: 'Career',
                                    badgeColor: '#8AA9FF',
                                    btnColor: 'rgba(25,118,210,0.50)',
                                },
                                {
                                    title: 'IKIGAI Finder',
                                    desc: 'Explore what you love and where you excel to find intersectionality of your purpose and direction. Use this to align your life with deeper meaning and unlocking higher levels of fulfillment.',
                                    icon: require('../assets/bulb.png'),
                                    bg: '#FFF3E0',
                                    frameColor: '#FFD59A',
                                    badge: 'Career',
                                    badgeColor: '#FFA07F',
                                    btnColor: '#FFA07F',
                                },
                                {
                                    title: 'Johari Window Builder',
                                    desc: 'Unpack open and hidden traits while discovering blind spots through valuable feedback, fostering self-awareness. Understand how you show up fully by seeing through the eyes of other.',
                                    icon: require('../assets/color palette.png'),
                                    bg: '#FCE4EC',
                                    frameColor: '#F8BBD9',
                                    badge: 'Self',
                                    badgeColor: '#FC95C0',
                                    btnColor: '#FC95C0',
                                },
                            ].map((test, idx) => (
                                <div
                                    key={idx}
                                    className={`rounded-xl shadow-lg p-4 sm:p-6 flex flex-col w-full min-h-[280px] sm:min-h-[320px] lg:min-h-[340px] items-start`}
                                    style={{ background: test.bg }}
                                >
                                    {/* Icon - now left aligned */}
                                    <div className="flex flex-col items-start justify-center mt-2 mb-2 w-full">
                                        <div
                                            className="flex items-center justify-center shadow-md"
                                            style={{
                                                background: test.frameColor,
                                                width: '48px',
                                                height: '40px',
                                                borderRadius: '12px',
                                                opacity: 1
                                            }}
                                        >
                                            <img
                                                src={test.icon}
                                                alt=""
                                                style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    opacity: 1,
                                                    filter: test.title === 'The 7 questions of understanding' ? 'brightness(1.2) contrast(1.1)' : 'none'
                                                }}
                                                className="sm:w-6 sm:h-6"
                                            />
                                        </div>
                                        <h3
                                            className="font-bold text-base sm:text-lg mt-3 mb-1 w-full"
                                            style={{ fontFamily: 'Roboto Slab, serif', textAlign: 'left' }}
                                        >
                                            {test.title}
                                        </h3>
                                    </div>
                                    {/* Badge and time */}
                                    <div
                                        className="flex items-center gap-2 mb-2 justify-start w-full"
                                    >
                                        <span className="text-xs font-semibold px-2 py-1 rounded" style={{ background: test.badgeColor, color: '#fff', fontFamily: 'Roboto Slab, serif', textAlign: 'left' }}>{test.badge}</span>
                                        <span className="text-gray-400 text-xs flex items-center" style={{ fontFamily: 'Roboto Slab, serif', textAlign: 'left' }}>
                                            <svg className="w-3 h-3 sm:w-4 sm:h-4 mr-1 inline" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3"></path>
                                                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"></circle>
                                            </svg>
                                            8-10 mins
                                        </span>
                                    </div>
                                    {/* Description */}
                                    <p className="text-gray-500 text-xs sm:text-sm flex-1 w-full" style={{ fontFamily: 'Roboto Slab, serif', textAlign: 'left' }}>{test.desc}</p>
                                    {/* Button */}
                                    <button
                                        className="mt-4 w-full py-2 rounded-lg font-bold shadow-md transition-colors hover:brightness-90 text-sm sm:text-base"
                                        style={{ background: test.btnColor, color: '#fff', boxShadow: '0 4px 16px 0 rgba(0,0,0,0.15)', fontFamily: 'Roboto Slab, serif' }}
                                        onClick={() => navigate('/login')}
                                    >
                                        Take a Test
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Gradient Call-to-Action Section */}
                <section
                    className="w-full flex items-center justify-center py-8 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-8"
                    style={{
                        background: 'linear-gradient(90deg, #8f44fd 0%, #e94b8b 100%)',
                        minHeight: '434.03px'
                    }}
                >
                    <div className="w-full max-w-7xl mx-auto flex flex-col items-center justify-center text-center">
                        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-white text-center mb-4" style={{ fontFamily: 'Roboto Slab, serif' }}>Ready to Discover Your True Self?</h2>
                        <p className="text-white text-sm sm:text-base md:text-lg text-center mb-6 sm:mb-8 max-w-2xl mx-auto">Join over 2 million people who have unlocked their potential with our personality assessment.</p>
                        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center w-full max-w-md sm:max-w-lg mx-auto">
                            <button
                                className="w-full sm:w-auto px-6 py-2 sm:py-3 bg-white text-[#9C27B0] rounded font-semibold shadow hover:bg-gray-100 transition text-sm sm:text-base border border-white"
                            >
                                Start Your Journey Today
                            </button>
                            <button
                                className="w-full sm:w-auto px-6 py-2 sm:py-3 bg-transparent border border-white text-white rounded font-semibold shadow transition text-sm sm:text-base"
                            >
                                Explore Personality Types
                            </button>
                        </div>
                    </div>
                </section>
                {/* {showModal && (
                    <div
                        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
                        onClick={() => setShowModal(false)}
                    >
                        <div
                            className="shadow-lg subscribe-section bg-white p-6 rounded-lg"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <h2 className="font-semibold mb-2 text-center">
                                Please subscribe to the paid version to unlock premium features
                            </h2>

                            <div className="mt-4 flex items-center justify-center">
                                <button
                                    className="bg-black text-white px-4 py-2 rounded"
                                    onClick={() => {
                                        setShowModal(false);
                                        setShowUpgradePopup(true);
                                    }}
                                >
                                    Upgrade
                                </button>
                            </div>
                        </div>
                    </div>
                )} */}
                {showUpgradePopup && (
                    <div
                        className="fixed inset-0 z-[3000] flex items-center justify-center bg-black bg-opacity-40"
                        onClick={() => setShowUpgradePopup(false)}
                    >
                        <div
                            className="bg-white w-[95%] max-w-4xl rounded-xl overflow-hidden shadow-lg"
                            style={{ position: 'absolute', top: '10px', overflow: 'auto', height: '96vh' }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white text-center py-6 px-4" style={{ position: 'relative' }}>
                                <img onClick={() => setShowUpgradePopup(false)} src={closer} alt="updated" style={{ width: '20px', margin: '6px auto', position: 'absolute', right: '20px', cursor: 'pointer' }} />
                                <img src={updated} alt="updated" style={{ width: '56px', margin: '6px auto' }} />
                                <h2 className="text-xl font-bold">Limited Time Offer - 50% Off!</h2>
                                <p className="text-sm mt-1">Special discount expires in 24 hours - Don’t miss out!</p>
                            </div>
                            <div className='border rounded-lg w-[90%] p-5 text-center mx-auto mt-4'>
                                <div className="flex justify-center py-4 items-center gap-2" >
                                    <img src={free} alt="free" style={{ width: '60px', }} />
                                    <p>Free</p>
                                </div>
                                <div className="flex justify-center py-4 items-center gap-5">
                                    <p>✔ Simple Tests</p>
                                    <p>✔ Quick Insights</p>
                                    <p>✔ No Feedback</p>
                                    <p>✔ You can try it only once</p>
                                </div>
                                <button 
                                    className="bg-[#000] text-white  p-2 px-5 rounded"
                                    onClick={() => {
                                        setShowUpgradePopup(false);
                                        handleTakeTestClick();
                                    }}
                                >
                                    Get Started
                                </button>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-6 pb-6 mt-8">
                                {/* Free Plan */}
                                <div className="border rounded-lg w-full p-5 text-center">
                                    <img src={Standard} alt="free" style={{ width: '56px', margin: '6px auto' }} />
                                    <h2 className="text-2xl font-bold mb-2">Standard</h2>
                                    <div className="text-2xl font-bold mb-2">15$</div>
                                    <ul className="text-sm text-gray-600 text-left mb-4 space-y-2">
                                        <li>✔ (3) tests of your choice</li>
                                        <li>✔  Dashboard, full reports</li>
                                        <li>✔ Limited analytics</li>
                                    </ul>
                                    <button className=" text-black w-full py-2 rounded bg-[#FFCC80]" >Current Plan</button>
                                </div>

                                {/* Premium Plan */}
                                <div className="relative border-2 border-blue-500 rounded-lg w-full p-5 text-center">
                                    <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-500 text-white text-xs px-3 py-1 rounded">Most Popular</span>
                                    <img src={Premium} alt="Premium" style={{ width: '56px', margin: '6px auto', }} />
                                    <h2 className="text-2xl font-bold mb-2">All access</h2>
                                    <p>Complete personality analysis</p>
                                    <div className=" font-bold text-xl mb-2">$144.99/year</div>
                                    <div className="text-green-600  text-xl mb-2">$12/Tests</div>
                                    <ul className="text-sm text-gray-600 text-left mb-4 space-y-2">
                                        <li>✔  (12) Tests</li>
                                        <li>✔ Pay once</li>
                                        <li>✔ lifetime access to everything and full reports</li>
                                        <li>✔ Each test is $12/per (Most Popular)</li>
                                        <li>✔ Personal growth recommendations</li>
                                    </ul>
                                    <button onClick={() => startCheckout('premium')} className="bg-blue-600 text-white w-full py-2 rounded">Get Started</button>
                                </div>

                                <div className="border rounded-lg w-full p-5 text-center">
                                    <div >
                                        <img src={premiumCrown} alt="Professional" style={{ width: '56px', margin: '6px auto', }} />
                                    </div>
                                    <h2 className="text-2xl font-bold mb-2">Premium</h2>
                                    <p>Professional personality insights</p>
                                    <div className=" font-bold text-xl mb-2">$199.99/year</div>
                                    <ul className="text-sm text-gray-600 text-left mb-4 space-y-2">
                                        <li>✔ Everything in all-access</li>
                                        <li>✔ + 1 hr consult w/coach</li>
                                        <li>✔ Personalized take home purpose plan & free PPP ebook. (Best Value)</li>
                                        <li>✔ Personalized personal plan</li>
                                    </ul>
                                    <button onClick={() => startCheckout('professional')} className="bg-[#AC2FC2] text-white w-full py-2 rounded">Get Started</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
};

export default PersonalityTestLanding; 